<template>
  <div
    class="p-field p-d-flex"
    :class="{'p-flex-column': !directionRow, 'direction-row': directionRow}"
  >
    <label
      v-if="label"
      :class="{
        'p-error': !!errorMessage,
        'p-focus': focus_status && !errorMessage,
      }"
      :for="id"
    ></label>
    <div class="p-d-flex p-flex-column span-container">
      <span
        :class="{
          'p-input-icon-left': iconClass != undefined && !iconRight && showIcon,
          'p-input-icon-right': iconClass != undefined && iconRight && showIcon,
        }"
      >
        <i v-if="iconClass != undefined && showIcon" :class="iconClass" />
        <Dropdown
          ref="dropdown"
          :disabled="disabled"
          :id="id"
          :class="[!!errorMessage ? 'p-invalid' : '', inputClass]"
          @change="onChange"
          @input="onInput"
          :modelValue="text.value"
          v-model="text.value"
          :placeholder="placeholder"
          @focus="focus_status = true"
          @blur="focus_status = false"
          :options="options"
          :optionValue="optionValue"
          :optionLabel="filterLabel ? filterLabel : optionLabel"
          :editable="editable"
          :filter="filter"
          :showClear="false"
          :style="style"
          :filterFields="filterFields"
        >
          <template #option="slotProps">
            {{
              slotProps.option[optionLabel] +
              (optionLabel1 != undefined
                ? " " + "(" + slotProps.option[optionLabel1] + ")"
                : "")
            }}
          </template>
        </Dropdown>
      </span>
      <small v-if="displayError && !!errorMessage" :class="{'p-error': true}">
        {{ errorMessage }}
      </small>
    </div>
  </div>
</template>

<script>
// import Dropdown from "primevue/dropdown";
import {defineAsyncComponent} from "vue";
import Dropdown from "primevue/dropdown";
import TBaseInput from "./TBaseInput";
import {useField} from "vee-validate/dist/vee-validate.min.js";
import {watch} from "vue";
import {reactive} from "@vue/reactivity";

export default {
  extends: TBaseInput,
  components: {Dropdown},

  setup(props, {emit}) {
    const {value, errorMessage} = useField(props.name, undefined, {
      initialValue: props.modelValue,
    });

    const text = reactive({
      value: value,
    });

    watch(
      () => props.modelValue,
      (first, second) => {
        text.value = first;
      }
    );

    let onChange = (e) => {
      emit("update:modelValue", e.value);
      props.changeAction(e.value);
    };

    let onInput = (e) => {
      emit("update:modelValue", e.target.value);
    };

    return {
      errorMessage,
      onChange,
      onInput,
      text,
    };
  },
  props: {
    style:{},
    showIcon: {default: true},
    showClear: {default: true},
    displayError: {type: Boolean, default: true},
    filter: {type: Boolean, default: false},
    editable: {type: Boolean, default: false},
    options: {
      type: Array,
      default: () => [],
    },
    filterFields:{
      type:Array,
      default: () => []
    },
    optionLabel: {
      Type: String,
      default: "name",
    },
    filterLabel: {
      Type: String,
      default: undefined,
    },
    optionLabel1: {
      Type: String,
      default: undefined,
    },
    optionValue: {
      Type: String,
      default: "name",
    },
    disabled: {type: Boolean, default: false},
    changeAction: {
      type: Function,
      default: function (e) {},
    },
  },
  mounted() {
    let that  = this
    this.$refs.dropdown.bindResizeListener = function() {
      if (!that.$refs.dropdown.resizeListener) {
        that.$refs.dropdown.resizeListener = () => {
          
        };
        window.addEventListener('resize', that.$refs.dropdown.resizeListener);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./../../style/components/input-text/base-input.scss";

.p-dropdown-trigger {
  border-left: 0px !important;
  width: 0px !important;
}

.p-dropdown {
  border-radius: 4px !important;
  @include f-input;
  height: 42px !important;
  color: $light-black;
}
.p-dropdown-item {
  color: $light-black !important;
  @include f-input;
}
</style>
